// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-100: rgb(11, 71, 254);
  --primary-90: rgba(11, 71, 254, 90%);
  --primary-80: rgba(11, 71, 254, 80%);
  --primary-70: rgba(11, 71, 254, 70%);
  --primary-60: rgba(11, 71, 254, 60%);
  --primary-50: rgba(11, 71, 254, 50%);
  --primary-40: rgba(11, 71, 254, 40%);
  --primary-30: rgba(11, 71, 254, 30%);
  --primary-20: rgba(11, 71, 254, 20%);
  --primary-10: rgba(11, 71, 254, 10%);
  --primary-05: rgba(11, 71, 254, 5%);
  --secondary-100: rgb(53, 0, 183);
  --secondary-90: rgba(53, 0, 183, 90%);
  --secondary-80: rgba(53, 0, 183, 80%);
  --secondary-70: rgba(53, 0, 183, 70%);
  --secondary-60: rgba(53, 0, 183, 60%);
  --secondary-50: rgba(53, 0, 183, 50%);
  --secondary-40: rgba(53, 0, 183, 40%);
  --secondary-30: rgba(53, 0, 183, 30%);
  --secondary-20: rgba(53, 0, 183, 20%);
  --secondary-10: rgba(53, 0, 183, 10%);
  --secondary-05: rgba(53, 0, 183, 5%);
  --white: #ffffff;
  --white-80: rgba(255, 255, 255, 0.8);
  --white-60: rgba(255, 255, 255, 0.6);
  --black: #000000;
  --black-10: #525252;
  --text-1: #1a1a1a;
  --text-2: #a1a1a1;
  --grey-light1: #d9d9d9;
  --grey-light2: #f4f4f4;
  --grey-light3: #f0f0f0;
  --grey-light4: rgb(245 242 255);
  --black-100: #000000;
  --black-15: rbga(0, 0, 0, 0.15); }

.sidenav-container {
  height: calc(100vh - 57px);
  width: 250px;
  background-color: var(--primary-20); }
  .sidenav-container .link {
    padding: 12px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-1);
    border-bottom: 1px solid var(--white); }
    .sidenav-container .link:hover, .sidenav-container .link.active {
      background-color: var(--primary-05);
      color: var(--primary-100); }

@media all and (max-width: 768px) {
  .sidenav-container {
    display: none; } }
`, "",{"version":3,"sources":["webpack://./src/assets/styles/settings/_colors.scss","webpack://./src/component/sidenav/sidenav.scss"],"names":[],"mappings":"AAAA;EACI,+BAAc;EACd,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,mCAAa;EAEb,gCAAgB;EAChB,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,oCAAe;EAEf,gBAAQ;EACR,oCAAW;EACX,oCAAW;EACX,gBAAQ;EACR,mBAAW;EAEX,iBAAS;EACT,iBAAS;EAET,sBAAc;EACd,sBAAc;EACd,sBAAc;EACd,+BAAc;EAEd,oBAAY;EACZ,+BAAW,EAAA;;ACvCf;EACI,0BAA0B;EAC1B,YAAY;EACZ,mCAAmC,EAAA;EAHvC;IAKQ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,qCAAqC,EAAA;IAT7C;MAWY,mCAAmC;MACnC,yBAAyB,EAAA;;AAKrC;EACI;IACI,aAAa,EAAA,EAChB","sourcesContent":[":root {\n    --primary-100: rgb(11, 71, 254);\n    --primary-90: rgba(11, 71, 254, 90%);\n    --primary-80: rgba(11, 71, 254, 80%);\n    --primary-70: rgba(11, 71, 254, 70%);\n    --primary-60: rgba(11, 71, 254, 60%);\n    --primary-50: rgba(11, 71, 254, 50%);\n    --primary-40: rgba(11, 71, 254, 40%);\n    --primary-30: rgba(11, 71, 254, 30%);\n    --primary-20: rgba(11, 71, 254, 20%);\n    --primary-10: rgba(11, 71, 254, 10%);\n    --primary-05: rgba(11, 71, 254, 5%);\n\n    --secondary-100: rgb(53, 0, 183);\n    --secondary-90: rgba(53, 0, 183, 90%);\n    --secondary-80: rgba(53, 0, 183, 80%);\n    --secondary-70: rgba(53, 0, 183, 70%);\n    --secondary-60: rgba(53, 0, 183, 60%);\n    --secondary-50: rgba(53, 0, 183, 50%);\n    --secondary-40: rgba(53, 0, 183, 40%);\n    --secondary-30: rgba(53, 0, 183, 30%);\n    --secondary-20: rgba(53, 0, 183, 20%);\n    --secondary-10: rgba(53, 0, 183, 10%);\n    --secondary-05: rgba(53, 0, 183, 5%);\n\n    --white: #ffffff;\n    --white-80: rgba(255, 255, 255, 0.8);\n    --white-60: rgba(255, 255, 255, 0.6);\n    --black: #000000;\n    --black-10: #525252;\n    \n    --text-1: #1a1a1a;\n    --text-2: #a1a1a1;\n\n    --grey-light1: #d9d9d9;\n    --grey-light2: #f4f4f4;\n    --grey-light3: #f0f0f0;\n    --grey-light4: rgb(245 242 255);\n\n    --black-100: #000000;\n    --black-15: rbga(0, 0, 0, 0.15);\n}\n","@import '../../assets/styles/settings/colors';\n.sidenav-container {\n    height: calc(100vh - 57px);\n    width: 250px;\n    background-color: var(--primary-20);\n    .link {\n        padding: 12px;\n        font-size: 14px;\n        font-weight: 600;\n        color: var(--text-1);\n        border-bottom: 1px solid var(--white);\n        &:hover, &.active {\n            background-color: var(--primary-05);\n            color: var(--primary-100);\n        }\n    }\n}\n\n@media all and (max-width: 768px) {\n    .sidenav-container {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
